import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Bell from './../../../../assets/icons/BellIcon.svg';
import classes from './NotificationIcon.module.scss';
import { manualAttendanceTableList , pendingLeavesApprovals } from '../../../../API/API';
import NotificationDrawer from './NotificationDrawer';
import { notificationAction } from '../../../../Redux/action/interactions';

const NotificationIcon = () => {
  const data = JSON.parse(localStorage.getItem('data'));
  const userID = localStorage.getItem('userID');
  const [tableData, setTableData] = useState([]);
  const [tableData2, setTableData2] = useState([]);
  const [changeData , setChangeData] = useState(0)
  const dispatch = useDispatch();

  const state = useSelector(state => state.interactions.notification)
  const handleClick = () => {
    if(state===false){
      dispatch(notificationAction(true))
    }else{
      dispatch(notificationAction(false))
    }
  }

  useEffect(() => {
    if (data && userID) {
      manualAttendanceTableList(userID, data.empid, data.token)
        .then(response => {
          setTableData(response.data)
          setChangeData(0)
        })
        .catch((error) => { console.log(error) })

        pendingLeavesApprovals(userID, data.empid, data.token)
        .then(response => {
          setTableData2(response.data)
          setChangeData(0)
        })
        .catch((error) => { console.log(error) })
    }
  }, [changeData])
 

  return (
    <>
    <NotificationDrawer dataChange={setChangeData}/>
      <div className={classes.NotificationIcon} onClick={handleClick}>
        <img src={Bell} alt="Bell Icon" />
        {tableData.length > 0 || tableData2.length > 0 ? <span>{tableData.length + tableData2.length}</span> : ""}
      </div>
    </>
  )
}

export default NotificationIcon